export const MODAL_STATUS_UPDATE = 'MODAL_STATUS_UPDATE';

export function setModalOpenStatus(payload) {
    return {type: MODAL_STATUS_UPDATE, payload: payload};
}

export const HIDE_MODAL = 'HIDE_MODAL';

export function hideModal() {
    return {type: HIDE_MODAL};
}


// WEBPACK FOOTER //
// ./src/_actions/modal.actions.js